<template>
  <div class="row">
    <div class="col-12">
        <div class="card">
        <div class="card-body">
            <h5 class="card-title font-weight-bold"> {{itemLabel}} </h5>
            <p class="card-text"> {{ itemDescription }}</p>
        </div>
        </div>
        <LoadingSpinner v-if="gettingData"/>

        <div v-else>
            <Table            
            class="mx-2 w-100"
            :headers="getHeaders"
            :cols="getCols"
            :data="tableData"
            :model="[]"
            :checkbox="false"
            :notselect="true"
            @openClient="openClient"
            @openOrder="openOrder"
            @openRecovery="openRecovery"
            >
        </Table>
        </div>        
    </div>
  </div>
</template>

<script>
import { usersService} from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";


export default {
    name: 'ListDataSaleMetrics',
    components: {
        Table,
        LoadingSpinner
    },
    data() {
        return {    
        gettingData: true,
        colsOrders: [
            [
                {
                value: "last_update",
                }
            ],           
            [
                {
                    value_label: "order_name",
                    value_emit: "order_id",
                    class: "text-primary",
                    type: "emit",
                    emit: "openOrder",
                },
            ],
            [
                {
                    value: "duplicate_reason",
                },                
            ],        
            [
                {
                    value: "status",
                },                
            ],
            [
                {
                    value_label: "client_name",
                    value_emit: "id",
                    class: "text-primary",
                    type: "emit",
                    emit: "openClient",
                },
            ],
        ],
        colsClients: [
            [
                {
                value: "last_update",
                }
            ],           
            [
                {
                    value_label: "client_name",
                    value_emit: "id",
                    class: "text-primary",
                    type: "emit",
                    emit: "openClient",
                },
            ],
            [
                {
                    value: "status",
                },                
            ]
        ],
        colsSales: [
            [
                {
                value: "last_update",
                }
            ],           
            [
                {
                    value_label: "client_name",
                    value_emit: "id",
                    class: "text-primary",
                    type: "emit",
                    emit: "openClient",
                },
            ],
    
        ],
        colsDeclinedRecoveryPaid: [
            [
                {
                    value_label: "client_name",
                    value_emit: "id",
                    class: "text-primary",
                    type: "emit",
                    emit: "openRecovery",
                },
            ],
            [
                {
                    value: "total_display",
                },
            ],
        ],
        headersClients: [
            {
            label: "Last Update",
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            },
            {
            label: this.$t("lang.column.name"),
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            },
            {
            label: this.$t("lang.column.status"),
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            }             
        ],
        headersOrders: [
            {
            label: "Last Update",
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            },
            {
            label: this.$t("lang.column.name"),
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            },
            {
            label: this.$t("lang.column.duplicate_reason"),
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            },
            {
            label: this.$t("lang.column.status"),
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            }, 
            {
            label: this.$t("lang.column.client"),
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            },           
        ],
         headersSales: [
            {
            label: "Last Update",
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            },
            {
            label: this.$t("lang.column.name"),
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            },
        ],
        headersDeclinedRecoveryPaid: [
            {
                label: this.$t("lang.column.name"),
                percentage: "50%",
                class: "overflowhide",
                permission: "AgencyBilling",
                id: 1,
            },
            {
                label: "Total",
                percentage: "50%",
                class: "overflowhide",
                permission: "AgencyBilling",
                id: 2,
            },
        ],
        data: [],
        }
    },
    props: {
        userType: {
            type: String,
            default: null
        },
        item: {
            type: String,
            default: null
        },
        itemLabel: {
            type: String,
            default: null
        },
        itemDescription: {
            type: String,
            default: null
        },
        userOliverSale: String,
        month: String,
    },
    computed:{
        tableData() {
            const isRecoveryOrPaused = this.item === 'recovery_clients' || this.item === 'paused_clients';
            if (!isRecoveryOrPaused || !this.data || this.data.length === 0) {
                return this.data || [];
            }
            let totalAvgMonthlyRevenue = 0;
            let totalMeetingsMensuels3m = 0;
            this.data.forEach((row) => {
                totalAvgMonthlyRevenue += parseFloat(row.avg_monthly_revenue) || 0;
                totalMeetingsMensuels3m += parseFloat(row.meetings_mensuels_3m) || 0;
            });
            const totalsRow = {
                totalRow: true,
                client_name: 'Total',
                last_update: '',
                status: '',
                avg_monthly_revenue: totalAvgMonthlyRevenue,
                meetings_mensuels_3m: totalMeetingsMensuels3m,
            };
            return [...this.data, totalsRow];
        },
        getHeaders(){
            const itemsClients = ['active_clients', 'paused_clients', 'recovery_clients', 'deleted_clients']
            if(itemsClients.includes(this.item)){
                if(this.item == 'paused_clients'){
                    this.headersClients.find( el => el.label == "Last Update").label="Standby date"
                    return this.headersClients
                }

                if(this.item == 'recovery_clients'){
                    this.headersClients.find( el => el.label == "Last Update").label="Recovery date"
                    return this.headersClients
                }    

                if(this.item == 'recovery_clients'){
                    this.headersClients.find( el => el.label == "Last Update").label="Recovery date"
                    return this.headersClients
                }    
                                
                return (this.item == 'active_clients') ? this.headersClients.filter( (el, i) => i > 0) : this.headersClients
            }

            const ItemsSales = ['new_clients', 'total_orders', 'avg_meeting_price']
            if(ItemsSales.includes(this.item)){

                if(this.item == 'new_clients'){
                    this.headersSales.find( el => el.label == "Last Update").label="Sign on date"
                    return this.headersSales
                }
                
                               
                return this.headersSales
            }

            const ItemsOrders = ['new_orders', 'new_orders_old_client']

            if(ItemsOrders.includes(this.item)){
                
                if(this.item == 'new_orders'){
                    this.headersOrders.find( el => el.label == "Last Update").label="Preparing date"
                    return this.headersOrders
                }

                if(this.item == 'new_orders_old_client'){
                    this.headersOrders.find( el => el.label == "Last Update").label="Preparing date"
                    return this.headersOrders
                }
                return this.headersOrders
            }

            if (this.item === 'declined_recovery_paid') {
                return this.headersDeclinedRecoveryPaid
            }
        },
        getCols(){
            const itemsClients = ['active_clients', 'paused_clients', 'recovery_clients', 'deleted_clients']
            if(itemsClients.includes(this.item)){
                return (this.item == 'active_clients') ? this.colsClients.filter( (el, i) => i > 0) : this.colsClients
            }

            const ItemsSales = ['new_clients', 'total_orders', 'avg_meeting_price']
            if(ItemsSales.includes(this.item)){
                return this.colsSales
            }

            const ItemsOrders = ['new_orders', 'new_orders_old_client']
            if(ItemsOrders.includes(this.item)){
                return this.colsOrders
            }

            if (this.item === 'declined_recovery_paid') {
                return this.colsDeclinedRecoveryPaid
            }
        }
    },
    mounted(){
        this.getData()

        if(this.item == 'recovery_clients' || this.item == 'paused_clients'){
            this.headersClients.push(
                {
            label: 'Avg. monthly revenue (3m)',
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            },  
            {
            label: 'Meetings/month (3m)',// this.$t("lang.column.status"),
            percentage: "10.5%",
            class: "overflowhide",
            permission: "AgencyBilling",
            id: 1,
            },       
            )

            this.colsClients.push(
                [
              {
                value: "avg_monthly_revenue",
              }
            ],
            [
              {
                value: "meetings_mensuels_3m",
              }
            ],
            )
        }
    },
    methods: {
        openClient(client_id) {
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
        },

        openRecovery() {
        let url = "/invoices_recovering/";
        window.open(url, "_blank");
        },

        openOrder(order_id) {
        let url = "/orders/" + order_id;
        window.open(url, "_blank");
        },

        getData(){
            if(this.item) {
                const validOptions = ['active_clients', 'paused_clients', 'recovery_clients', 'deleted_clients', 'new_clients', 'new_orders', 'new_orders_old_client', 'declined_recovery_paid']
                
                if (validOptions.includes(this.item)  ) {                
                     this.gettingData = true
                    usersService.getOliverSalesDashboardDetail(this.item, this.userOliverSale, this.month, this.userType)
                    .then( res => {
                        if (res.result){
                            if (this.item === 'declined_recovery_paid') {
                                this.data = res.result.map((row) => ({
                                    ...row,
                                    total_display:
                                        row.total != null && row.total !== ''
                                            ? `${Number(row.total).toFixed(2)} €`
                                            : '',
                                }))
                            } else {
                                this.data = res.result
                            }
                        }
                        this.gettingData = false
                    })
                    .catch( err => console.err(err))
                }
            }
            
        }
    }
}
</script>